
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import GeneratorDialog from '@/components/Admin/GeneratorDialog.vue';
import Card from '@/components/material/Card.vue';
import DlgTrainingTemplateDelete from '@/modules/admin/trainings/_components/DlgTrainingTemplateDelete.vue';
import DatePicker from '@/components/date-picker.vue';
import TimePicker from '@/components/TimePicker.vue';
import CeoTable from '@/modules/admin/trainings/_components/CeoTable.vue';
import GuestTable from '@/modules/admin/trainings/_components/GuestTable.vue';
import DlgSendAllCeoMail from '@/modules/admin/trainings/_components/DlgSendAllCeoMail.vue';
import DialogCreateTrainingGuest from '@/modules/admin/trainings/_components/DialogCreateTrainingGuest.vue';
import DialogInviteTrainingGuest from '@/modules/admin/trainings/_components/DialogInviteTrainingGuest.vue';

@Component({
  components: {
    DialogInviteTrainingGuest,
    DialogCreateTrainingGuest,
    DlgSendAllCeoMail,
    GuestTable, CeoTable, TimePicker, DatePicker, DlgTrainingTemplateDelete, Card, GeneratorDialog},
})
export default class VTrainingDetails extends Vue {
  public $refs!: {
    form: any,
    dlgGroup: any,
    dlgGuests: any,
  };

  @Prop({type: String, default: ''}) private id!: string;

  @Action('admin/trainings/readOne') private readOne!: (params: any) => Promise<any>;
  @Action('admin/companies/read') private readCompanies!: () => Promise<any>;
  @Action('admin/ceos/read') private readCeos!: () => Promise<any>;

  @Action('admin/trainings/readTemplates') private readTemplates!: (params: any) => Promise<any>;
  @Action('admin/trainings/readGuests') private readGuests!: (params: any) => Promise<any>;
  @Action('admin/trainings/createTemplate') private createTemplate!: (params: any) => Promise<any>;
  @Action('admin/trainings/updateTemplate') private actionUpdateTemplate!: (params: any) => Promise<any>;

  @Action('admin/trainings/update') private updateTraining!: (params: any) => Promise<any>;

  @Action('common/loader/start') private start!: () => Promise<any>;
  @Action('common/loader/stop') private stop!: () => Promise<any>;

  @Getter('admin/trainings/one') private training!: any;
  @Getter('admin/trainings/templates') private templates!: any;
  @Getter('admin/trainings/guests') private trainingGuests!: any;

  @Getter('admin/companies/all') private companies!: any;
  @Getter('admin/ceos/all') private ceos!: any;
  @Getter('admin/guests/all') private guests!: any;
  @Getter('common/rules/all') private rules!: any;

  private loading: boolean = false;
  private localTraining: any = {};
  private deadlineDate: string = '';
  private deadlineTime: string = '';
  private date: string = '';
  private time: string = '';
  private tab: string = 'ceo';
  private valid: boolean = true;

  private mounted() {
    this.init();
  }

  private async init() {
    this.start();
    this.loading = true;
    const promises: Array<Promise<any>> = [
      this.readOne({id: this.id}),
      this.readCompanies(),
      this.readCeos(),
      this.readTemplates({id: this.id}),
      this.readGuests({id: this.id}),
    ];
    await Promise.all(promises);

    this.localTraining = this.training;
    if (!this.localTraining.description) {
      this.localTraining.description = '';
    }
    const deadline = new Date(this.localTraining.deadline);
    const date = new Date(this.localTraining.date);
    this.deadlineDate = `${deadline.getDate()}.${deadline.getMonth() + 1}.${deadline.getFullYear()}`;
    this.date = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    this.deadlineTime = `${deadline.getHours()}:${(deadline.getMinutes() < 10 ? '0' : '')}${deadline.getMinutes()}`;
    this.time = `${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '')}${date.getMinutes()}`;

    this.loading = false;
    this.stop();
  }

  private async update() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      const deadlineDate = this.deadlineDate.split('.').map((e: string) => parseInt(e, 10));
      const deadlineTime = this.deadlineTime.split(':').map((e: string) => parseInt(e, 10));
      this.localTraining.deadline =
        new Date(deadlineDate[2], deadlineDate[1] - 1, deadlineDate[0], deadlineTime[0], deadlineTime[1]);

      const trainingDate = this.date.split('.').map((e: string) => parseInt(e, 10));
      const trainingTime = this.time.split(':').map((e: string) => parseInt(e, 10));
      this.localTraining.date =
        new Date(trainingDate[2], trainingDate[1] - 1, trainingDate[0], trainingTime[0], trainingTime[1]);

      await this.updateTraining(this.localTraining);
      await this.init();
      this.loading = false;
    }
  }

  private async saveTemplate(elem) {
    this.loading = true;
    const template = {
      title: elem.title,
      subject: elem.subject,
      html: elem.html,
      template: elem.object,
    };
    await this.createTemplate({id: this.localTraining.id, template});
    await this.readTemplates({id: this.id});
    this.loading = false;
  }

  private async updateTemplate(elem) {
    this.loading = true;
    const template = {
      id: elem.id,
      title: elem.title,
      subject: elem.subject,
      html: elem.html,
      template: elem.object,
    };
    await this.actionUpdateTemplate({id: this.localTraining.id, template});
    await this.readTemplates({id: this.id});
    this.loading = false;
  }
}
